import { render, staticRenderFns } from "./RoleAdded.vue?vue&type=template&id=03f1980a&scoped=true"
import script from "./RoleAdded.vue?vue&type=script&lang=js"
export * from "./RoleAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f1980a",
  null
  
)

export default component.exports